/**
 * Labstep
 *
 * @module prosemirror/nodes/file
 * @desc File node
 */

import type { LabstepNode } from 'labstep-web/prosemirror/nodes/types';
import { getAttrsForId } from 'labstep-web/prosemirror/nodes/utils';
import type { Node as ProseMirrorNode } from 'prosemirror-model';

const key = 'file';

export const NodeFile: LabstepNode = {
  key,
  spec: {
    attrs: {
      id: { default: null },
      fullWidth: { default: false },
      width: { default: null },
    },
    inline: true,
    group: 'inline',
    marks: '',
    // atom: true,
    draggable: true,
    parseDOM: [
      { tag: 'span', getAttrs: getAttrsForId(key) },
      // Parse img tags with labstep-file-id attribute (from Word paste)
      {
        tag: 'img[labstep-file-id]',
        getAttrs(dom: HTMLElement | string): { id: number } | null {
          if (typeof dom === 'string') {
            return null;
          }
          const id = dom.getAttribute('labstep-file-id');
          return id ? { id: Number.parseInt(id, 10) } : null;
        },
      },
    ],
    toDOM(node: ProseMirrorNode) {
      const { id } = node.attrs;
      return ['span', { [`data-${key}-id`]: id }];
    },
  },
};
